import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import Exclusions from "./Exclusions";
import FileUpload from "./FileUpload";
import HowItWorks from "./HowItWorks"; // Import the How It Works page
import Login from "./Login";
import Pricing from "./Pricing";
import ProtectedRoute from "./ProtectedRoute";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        {/* <Route path="/register" element={<Register />} /> */}
        <Route
          path="/upload"
          element={
            <ProtectedRoute>
              <FileUpload />
            </ProtectedRoute>
          }
        />
        <Route
          path="/exclusions"
          element={
            <ProtectedRoute>
              <Exclusions />
            </ProtectedRoute>
          }
        />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/how-it-works" element={<HowItWorks />} />{" "}
        {/* Added How It Works route */}
      </Routes>
    </Router>
  );
}

export default App;
